import React, { useEffect, useState } from "react";
import { Box, Fade, IconButton, Modal } from "@mui/material";
import ReactPlayer from "react-player";
import { Close } from "@mui/icons-material";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: 1.4,
};

const VideoPlayer = ({ open, onClose, url, options }) => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // if (open) setLoading(true);
    }, [open]);
    
    const onVideoReady = () => {
        console.log("Ready")
    }

    return (
        <Modal open={open} onClose={onClose}>
            <>
                <div className="absolute right-2 top-1 z-10">
                    {options}
                    <IconButton onClick={onClose} >
                        <Close className="text-4xl text-white" />
                    </IconButton>
                </div>
                <Fade in={open}>
                    <Box className="" sx={style}>
                        <ReactPlayer playing controls url={url} />
                    </Box>
                </Fade>
            </>
        </Modal>
    )
}

export default VideoPlayer;